var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReverseWithdrawal01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.964 25.5661L33.7351 18.8771C33.2043 15.9881 32.9389 14.5436 31.8878 13.6883C30.8368 12.833 29.327 12.833 26.3075 12.833H18.1926C15.173 12.833 13.6632 12.833 12.6121 13.6883C11.5611 14.5436 11.2957 15.9881 10.7649 18.8771L9.53594 25.5661C8.43414 31.5627 7.88325 34.5611 9.57963 36.5305C11.276 38.4997 14.4098 38.4997 20.6775 38.4997H23.8224C30.0902 38.4997 33.224 38.4997 34.9203 36.5305C36.6167 34.5611 36.0658 31.5627 34.964 25.5661Z",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2474 19.25V31.1667M17.6641 27.5L22.2474 32.0833L26.8307 27.5",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7474 20.1667C39.0349 20.0216 39.2847 19.8389 39.5068 19.6084C40.5807 18.4938 40.5807 16.6997 40.5807 13.1116C40.5807 9.52343 40.5807 7.72937 39.5068 6.61469C38.4328 5.5 36.7043 5.5 33.2474 5.5H11.2474C7.79043 5.5 6.06194 5.5 4.98801 6.61469C3.91406 7.72937 3.91406 9.52343 3.91406 13.1116C3.91406 16.6997 3.91406 18.4938 4.98801 19.6084C5.21001 19.8389 5.45997 20.0216 5.7474 20.1667",
    stroke: "#3371E8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseWithdrawal01);
export default __webpack_public_path__ + "static/media/reverse-withdrawal-01.18a34cde8827b2f0435a7f40f450780e.svg";
export { ForwardRef as ReactComponent };